export default {"src":"/_next/static/media/trek.319f3bb8.svg","height":42,"width":74,"blurWidth":0,"blurHeight":0};